import { getJsonFreeStorageItem } from './storageUtils';
import { RECENT_SEARCHES_ALLOWED_SIZE } from '../constants/SavedSearches';

export const updateRecentItems = (recentSearches, newSearch) => {
  let newRecentSearches = [...recentSearches];

  const isElementAlreadyInRecent = newRecentSearches.includes(newSearch);

  if (!newRecentSearches.length) {
    newRecentSearches = [newSearch];
  } else if (isElementAlreadyInRecent) {
    const index = newRecentSearches.findIndex((searchName) => searchName === newSearch);

    newRecentSearches.splice(index, 1);
    newRecentSearches.unshift(newSearch);
  } else if (newRecentSearches.length < RECENT_SEARCHES_ALLOWED_SIZE) {
    newRecentSearches.unshift(newSearch);
  } else {
    newRecentSearches.pop();
    newRecentSearches.unshift(newSearch);
  }

  return newRecentSearches;
};

export const updatePinnedItems = (pinnedItems, newPinnedSearch, shouldPinItem) => {
  let newPinnedItems = [...pinnedItems];

  if (shouldPinItem) {
    if (!newPinnedItems.length) {
      newPinnedItems.push(newPinnedSearch);
    } else {
      newPinnedItems.unshift(newPinnedSearch);
    }
  } else {
    if (newPinnedItems.length === 1) {
      newPinnedItems = [];
    } else {
      newPinnedItems = newPinnedItems.filter((item) => item !== newPinnedSearch);
    }
  }

  return newPinnedItems;
};

export const getFullHistoryItemsData = (selectOptions, historyItems, historyKey) =>
  historyItems.map((searchName, index) => {
    const fullObj = selectOptions.find((option) => option.searchName === searchName);

    return { ...fullObj, id: `${historyKey}_${index}` };
  });

export const getSearchHistoryByStoreKey = (storeKey, allOptions = []) => {
  const enhancedSearchHistory = getJsonFreeStorageItem('enhancedSearchHistory') || {};
  const currentHistory = enhancedSearchHistory[storeKey] || {};

  //we have to remove items that are no longer available to be selected
  //for example when user unpublish repository, but it was previously in recent or pinned lists
  const recent =
    currentHistory.RECENT?.filter((item) =>
      allOptions.find(({ searchName }) => searchName === item)
    ) || [];
  const pinned =
    currentHistory.PINNED?.filter((item) =>
      allOptions.find(({ searchName }) => searchName === item)
    ) || [];

  return { recent, pinned };
};

export const saveSearchHistoryByStoreKey = (storeKey, recent, pinned) => {
  const enhancedSearchHistory = getJsonFreeStorageItem('enhancedSearchHistory') || {};

  const searchHistoryObj = {
    ...enhancedSearchHistory,
    [storeKey]: {
      RECENT: recent,
      PINNED: pinned,
    },
  };

  localStorage.setItem('enhancedSearchHistory', JSON.stringify(searchHistoryObj));
};
